import { Reveal } from "@/components/site/Reveal";
import { PROCESS } from "@/data/content";

export const Timeline = () => {
  return (
    <div data-testid="how-we-work-timeline">
      {/* Desktop: horizontal */}
      <div className="relative hidden lg:block">
        <div className="absolute left-0 right-0 top-[42px] h-px bg-slate-200" />
        <div className="grid grid-cols-6 gap-4">
          {PROCESS.map((step, i) => (
            <Reveal key={step.no} delay={i * 0.08}>
              <div className="relative">
                <div className="flex items-center gap-3">
                  <span className="flex h-[52px] w-[52px] items-center justify-center rounded-full border border-slate-200 bg-white font-[Outfit] text-lg font-bold text-[color:var(--brand-blue)]">
                    {step.no}
                  </span>
                  <span className="h-2 w-2 rounded-full bg-[color:var(--brand-red)]" />
                </div>
                <h3 className="mt-6 text-xl font-bold text-slate-950">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      {/* Mobile: vertical */}
      <div className="relative lg:hidden">
        <div className="absolute bottom-2 left-[25px] top-2 w-px bg-slate-200" />
        <div className="space-y-8">
          {PROCESS.map((step, i) => (
            <Reveal key={step.no} delay={i * 0.05}>
              <div className="relative flex gap-5">
                <span className="z-10 flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-full border border-slate-200 bg-white font-[Outfit] text-lg font-bold text-[color:var(--brand-blue)]">
                  {step.no}
                </span>
                <div className="pt-1.5">
                  <h3 className="text-xl font-bold text-slate-950">{step.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{step.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Timeline;
